import React from "react";
import { connect } from "react-redux";
import { requestTransactionsPractitioner,
    searchTransactionsPractitioners } from "../../actions/practitioners.action";

import {
    Container,
    Row,
    Col
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import CardStat from "../../components/stats/CardStat";
import TableData from "../../components/tables";


class Transactions extends React.Component
{
    constructor(props) {
        super(props);
        this.props.loadData(uuid);
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                {this.props.practitioners.fetching ? (
                    <div className="flex-center">
                        <div className="text-center d-block">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <Row noGutters className="page-header py-4">
                            <PageTitle title="Nom Prenom" subtitle="Transactions" className="text-sm-left mb-3"/>
                        </Row>
                        <Row>
                            <Col className="col-lg col-lg-3 mb-3">
                                <CardStat
                                    label="Crédits"
                                    value="22 540"
                                    icon={<i className="material-icons cardStat__icon">euro_symbol</i>}
                                />
                            </Col>
                            <Col className="col-lg col-lg-3 mb-3">
                                <CardStat
                                    label="Débits"
                                    value="22 540"
                                    icon={<i className="material-icons cardStat__icon">euro_symbol</i>}
                                />
                            </Col>
                            <Col className="col-lg col-lg-3 mb-3">
                                <CardStat
                                    label="Total"
                                    value="22 540"
                                    icon={<i className="material-icons cardStat__icon">euro_symbol</i>}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                                <TableData

                                    tableData="practitioners"
                                    dataColumns={[
                                        {
                                            Header: "Identifiant technique",
                                            accessor: "uuid",
                                            className: "text-center"
                                        }
                                    ]}
                                    pageSize={20}
                                    title={"Liste des transactions"}

                                />
                            </Col>
                        </Row>
                    </div>
                )};
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        practitioners: state['practitioners'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (uuid) => dispatch(requestTransactionsPractitioner(uuid)),
    searchData: (uuid, search) => dispatch(searchTransactionsPractitioners(uuid, search))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Transactions);



// WEBPACK FOOTER //
// ./src/views/Practitioners/Transactions.js